import { DataProps } from '../types';

export const getRowId = (row: DataProps): string => row.rowId || '';
